import "./price.css"
import * as React from "react";
import  { RouterHistory } from 'react-router';
import  {AppUser} from "../../shared/authorization";
import {compose} from "../../utility";
import withFade from "../../account/shared/animationHOC";
import {withSnackbar} from "../../shared/snackbar";
import {withAppUser} from "../../shared/authorization";
import {withRouter} from "react-router-dom";
import {FEE_AMOUNT} from "../../configurations";
type Props = {
    history: RouterHistory,
    user: AppUser,
};
const regular = {

    one: {
        title: "Free",
            price: 0,
            billingCode: "free-regular",
            description: "30 days",
            priceOverview: "Free Version",
            ctaText: "30 Days from subscription",
    },
    two: {
        title: "Standard",
            price: FEE_AMOUNT,
            billingCode: "standard-regular",
            description: "Digital signatures.\n Document edit.\n Pdf management.\n",
            priceOverview: "Yearly subscription",
            ctaText: "Buy Subscription",
    },
};


class PricingCardContainer extends React.Component<Props, null> {
    getPrice(price) {
        const p = price.toString().split('.'),
            d = p[0]
        return d
    }
    redirect() {
        history.pushState('payment/setting', {});
        window.location.href = 'setting';
    }

    render() {

        const {history} = this.props

        return (
            <section>


                <div className="container">
                    <div className="pricingCard">

                        <div className="title">
                            {regular.one.title}
                        </div>

                        <div className="card">

                            <h2 className="price">
                                <span className="price__currency">$</span>
                                <span className="price__dollar">{this.getPrice(regular.one.price)}</span>
                            </h2>

                            <p className="price-overview">{regular.one.priceOverview}</p>

                            <p className="description">{regular.one.description}</p>

                        </div>
                        <a className="bttn bttn-primary">{regular.one.ctaText}</a>

                    </div>
                    <div className="pricingCard featured">

                        <div className="title">
                            {regular.two.title}
                        </div>

                        <div className="card">

                            <h2 className="price">
                                <span className="price__currency">$</span>
                                <span className="price__dollar">{this.getPrice(regular.two.price)}</span>
                            </h2>

                            <p className="price-overview">{regular.two.priceOverview}</p>

                            <p className="description">{regular.two.description}</p>

                        </div>
                        <a className="bttn bttn-primary" onClick={() => this.redirect()}>{regular.two.ctaText}</a>
                    </div>
                </div>
            </section>
        );
    }
}

export default compose(
    withFade,
    withSnackbar,
    withAppUser,
    withRouter,
)(PricingCardContainer);